module.exports = __webpack_public_path__ + "img/lightcave.52150edc.jpg";